import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact'
import { facetNameTranslations, isFrench } from '../config'

export default ({ facet }) => {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];

    return (
        <li class='ns-sidebar-dropdown'>
            <div class="ns-facet-title">
                {isFrench ? facetNameTranslations[facet.name] : facet.name}
            </div>
            <div class="ns-sidebar-submenu">
                <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>
                        <input
                            type="number"
                            class="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-min`}
                            value={range[0]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                if(e.currentTarget.value < min) {
                                    updateRange([min, range[1]])
                                } else if (e.currentTarget.value >= max) {
                                    updateRange([(range[1] - 1), range[1]])
                                } else {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <input
                            type="number"
                            class="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-max`}
                            value={range[1]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                if (e.currentTarget.value > max) {
                                    updateRange([range[0], max])
                                } else if (e.currentTarget.value <= min) {
                                    updateRange([range[0], (range[0] + 1)])
                                } else {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }
                            }}
                        />
                    </div>
                </div>
                <RangeSlider id={facet.id} />
            </div>
        </li>
    )
}
